export const UAM_WS_KEEP_ALIVE_INTERVAL = 9 * 60 * 1000;
export const UAM_WS_KEEP_ALIVE_MESSAGE = '{}';
